<template>
  <div>
    <el-dialog title="Postagem" center :visible.sync="dialog.post" width="80%" top="2vh">
      <el-table :data="tablePrepost" stripe size="small" style="width: 100%"
        :default-sort="{ prop: 'content', order: 'ascending' }">
        <el-table-column prop="tag" :label="$t('etiqueta')" />
        <el-table-column align="center" prop="value" :label="$t('valor-correio')">
          <template slot-scope="scope">{{
            +scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}</template>
        </el-table-column>
        <el-table-column align="center" prop="pricetable" :label="$t('valor-tabela')">
          <template slot-scope="scope">{{
            +scope.row.pricetable
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}</template>
        </el-table-column>
        <el-table-column align="right" prop="diff" :label="$t('diferenca')">
          <template slot-scope="scope">
            <el-tag :type="+scope.row.diff < 0 ? 'danger' : +scope.row.diff < 20 ? 'warning' : 'success'">{{
              +scope.row.diff
              | currency("R$ ", 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
              })
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="right" prop="percentual" label="%">
          <template slot-scope="scope">{{
            (+scope.row.percentual).toFixed(0)
          }} %
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.post = false">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Desconto" center :visible.sync="dialog.discount" width="50%" top="2vh">
      <el-form :model="form">
        <el-row :gutter="5">
          <el-col :xs="24">
            <el-form-item :label="$t('descricao')">
              <el-input type="textarea" :rows="6" v-model="ruleForm.discount" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDiscount()">Salvar</el-button>
      </span>
    </el-dialog>


    <el-dialog title="Serviços adicionais" center :visible.sync="dialog.servicesadd" width="80%" top="2vh">
      <el-form :model="form">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('descricao')">
              <el-input v-model="form.content" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
            <el-form-item :label="$t('valor')">
              <el-input type="number" v-model="form.value" maxlength="10">
                <el-button slot="append" type="default" @click="add()">Adicionar</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableServices.filter(x => x.id == current)" stripe style="width: 100%"
        :default-sort="{ prop: 'content', order: 'ascending' }">
        <el-table-column prop="content" :label="$t('descricao')" />
        <el-table-column prop="value" :label="$t('valor')">
          <template slot-scope="scope">{{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}</template>
        </el-table-column>

        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" @click="remove(scope.$index)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>

    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('gerar-fatura')"></el-page-header>
    </el-card>
    <el-card>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item name="1">
          <template slot="title">Filtrar</template>
          <el-form :model="ruleForm" ref="ruleForm" label-position="top" :status-icon="true" :inline-message="true">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker v-model="ruleForm.start" type="daterange" align="right" unlink-panels range-separator="à"
                format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
            </el-form-item>
            <el-row type="flex">
              <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <el-form-item :label="$t('cliente')" prop="name">
                  <CustomerList v-model="ruleForm.customer" />
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-show="user.type === '1'">
                <el-form-item :label="$t('tipo-cliente')" prop="customerType">
                  <el-select v-model="ruleForm.customerType" clearable placeholder="Selecione  uma opção">
                    <el-option key="1" label="Cliente" value="1" />
                    <el-option key="2" label="Franquia" value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <el-form-item :label="$t('tipo-faturamento')" prop="billetType">
                  <el-select v-model="ruleForm.billetType" clearable placeholder="Selecione  uma opção">
                    <el-option key="3" label="Semanal" value="3" />
                    <el-option key="2" label="Quinzenal" value="2" />
                    <el-option key="1" label="Mensal" value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="12">
                <el-form-item label="Faturar Serviços" prop="serviceType">
                  <el-radio-group v-model="ruleForm.serviceType">
                    <el-radio class="small" label="all">Todos</el-radio>
                    <el-radio class="small" label="courier">Correios</el-radio>
                    <el-radio class="small" label="shipping">Transportadora</el-radio>
                    <el-radio class="small" label="euentrego">Eu Entreugo</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="ruleForm.serviceType === 'courier'" :label="$t('servico')" prop="name">
                  <ServicesList v-model="ruleForm.service" />
                </el-form-item>
                <el-form-item v-if="ruleForm.serviceType === 'shipping'" :label="$t('transportadora')" prop="shipping">
                  <ShippingList v-model="ruleForm.shipping" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-button type="primary" autofocus @click="fetchRecords()">{{
            $t("filtrar")
          }}</el-button>
        </el-collapse-item>
        <el-collapse-item name="2" :disabled="tableData.length === 0">
          <template slot="title">Resultado</template>
          <div class="container-fluid py-4">
            <div class="row">
              <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                <div class="card">
                  <div class="card-body p-3">
                    <div class="row">
                      <div class="col-9">
                        <div class="numbers">
                          <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Custo</p>
                          <h5 class="font-weight-bolder">
                            {{
                              header.valueCourier
                              | currency("R$ ", 2, {
                                thousandsSeparator: ".",
                                decimalSeparator: ",",
                              })
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-3 text-end">
                        <div class="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                          <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                <div class="card">
                  <div class="card-body p-3">
                    <div class="row">
                      <div class="col-8">
                        <div class="numbers">
                          <p v-if="ruleForm.customerType === '2'" class="text-sm mb-0 text-uppercase font-weight-bold">
                            Valor Clientes</p>
                          <p v-else class="text-sm mb-0 text-uppercase font-weight-bold">Valor Tabela</p>
                          <h5 class="font-weight-bolder">
                            {{
                              header.valuePricetable
                              | currency("R$ ", 2, {
                                thousandsSeparator: ".",
                                decimalSeparator: ",",
                              })
                            }}
                          </h5>
                          <p class="mb-0 txt-12">
                            <span class="text-sm font-weight-bolder"
                              :class="header.percentualCourier > 0 ? 'text-success' : 'text-danger'">{{
                                header.percentualCourier
                                | currency("", 2, {
                                  thousandsSeparator: ".",
                                  decimalSeparator: ",",
                                })
                              }}%</span>
                            sobre o custo
                          </p>
                        </div>
                      </div>
                      <div class="col-4 text-end">
                        <div class="icon icon-shape bg-gradient-orange shadow-primary text-center rounded-circle">
                          <i class="ni ni-check-bold text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                <div class="card">
                  <div class="card-body p-3">
                    <div class="row">
                      <div class="col-8">
                        <div class="numbers">
                          <p class="text-sm mb-0 text-uppercase font-weight-bold">Qtde Clientes</p>
                          <h5 class="font-weight-bolder">
                            {{ header.countCustomer }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-4 text-end">
                        <div class="icon icon-shape bg-gradient-green shadow-primary text-center rounded-circle">
                          <i class="ni ni-single-02 text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                <div class="card">
                  <div class="card-body p-3">
                    <div class="row">
                      <div class="col-8">
                        <div class="numbers">
                          <p class="text-sm mb-0 text-uppercase font-weight-bold">Total Postagens</p>
                          <h5 class="font-weight-bolder">
                            {{ header.countPost }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-4 text-end">
                        <div class="icon icon-shape bg-gradient-info shadow-primary text-center rounded-circle">
                          <i class="ni ni-world text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--el-row :gutter="5">
            <el-card v-for="item of tablePartners" :key="item.partnerId" class="box-card">
              <div slot="header" class="clearfix">
                <span>{{ item.partnerName }}</span>
                <el-button style="float: right; padding: 3px 0" type="text">Serviços Adicionais</el-button>
              </div>
              <div v-for="o in 4" :key="o" class="text item">
                {{'List item ' + o }}
              </div>
            </el-card>

          </el-row-->
          <el-table :data="tableData" ref="tableInvoice" style="width: 100%" size="mini" show-summary
            v-if="tableData.length > 0" :summary-method="getSummaries">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column sortable prop="customer"
              :label="ruleForm.customerType === '2' ? $t('parceiro') : $t('cliente')" width="180">
              <template slot-scope="scope">
                {{ scope.row.companyname }}
                <el-tag size="mini" v-if="ruleForm.customerType !== '2'">{{ scope.row.financial }}</el-tag>
                <el-tag size="mini" type="warning" v-if="ruleForm.customerType === '2'">Taxa Marketing {{ scope.row.factor
                }}%</el-tag>
                <el-tag size="mini" type="warning" v-if="ruleForm.customerType === '2'">Taxa Plataforma {{ scope.row.plataform
                }}%</el-tag>
                <el-tag size="mini" type="warning" v-else-if="+scope.row.factor < 100">Taxa de serviço {{ scope.row.factor
                }}%</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('valor-correio')">
              <template slot-scope="scope">
                {{
                  scope.row.value
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}
              </template>
            </el-table-column>
            <el-table-column prop="services" :label="$t('valor-servico')">
              <template slot-scope="scope">
                {{
                  scope.row.services
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}
                <el-button size="mini" type="info" icon="el-icon-plus" @click="show(scope.row.customerId)" />
              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" :label="$t('valor-tabela')">
              <template slot-scope="scope">
                <el-tag type="info" title="Valor Postagens">{{
                  scope.row.price
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}</el-tag>
                <el-tag type="warning" title="Valor Reversas">{{
                  scope.row.reversePricetable
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="discount" :label="$t('desconto')" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.discount" :controls="false" class="discount"
                  @change="calc(scope.$index)" @blur="calc(scope.$index)" :precision="2" :step="0.1"></el-input-number>
                <el-button size="mini" type="info" @click="discount(scope.row.customerId)">Detalhar</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="duaAt" :label="$t('venc-boleto')" width="150">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.dueAt" type="date" format="dd/MM/yyyy" placeholder="Pick a day">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="total" :label="$t('valor-total')">
              <template slot-scope="scope">
                {{
                  scope.row.total
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}
                <el-tag v-if="+scope.row.credit > 0" type="success">{{
                  scope.row.credit
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="#" width="290" v-if="ruleForm.customerType !== '2'">
              <template slot-scope="scope">
                <el-badge :value="scope.row.count" class="item-badge">
                  <el-button :disabled="scope.row.count === 0" size="mini"
                    @click="view(scope.row.customerId, 'post')">Postagens</el-button>
                </el-badge>
                <el-badge :value="scope.row.reverseTotal" class="item-badge">
                  <el-button :disabled="scope.row.reverseTotal === 0" size="mini"
                    @click="view(scope.row.customerId, 'reverse')">Reversas</el-button>
                </el-badge>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { InvoiceServices } from "@/services/customers/invoice.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import ShippingList from "@/xpost/views/register/shipping/ShippingList";

export default {
  name: "InvoiceAdd",
  components: {
    ServicesList,
    ShippingList,
    CustomerList,
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    const today = new Date();
    return {
      id: "",
      selected: "",
      header: {
        valueCourier: 0,
        valuePricetable: 0,
        countPost: 0,
        countCustomer: 0,
      },
      tableData: [],
      tablePartners: [],
      user: { type: "1" },
      activeName: "1",
      tableServices: [],
      tablePrepost: [],
      dialog: {
        servicesadd: false,
        post: false,
        discount: false,
      },
      current: "",
      form: {
        content: "",
        value: 0,
      },
      ruleForm: {
        start: [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth() + 1, 0),
        ],
        customer: "",
        service: "",
        customerType: "",
        billetType: "",
        discount: "",
        serviceType: "all",
      },
    };
  },
  methods: {
    view(customer, type) {
      const vm = this;
    const loading = vm.$loading(vm.$options.loading);
      InvoiceServices.prepost({
        startedAt: vm.ruleForm.start[0],
        finishedAt: vm.ruleForm.start[1],
        customer: customer,
        service: vm.ruleForm.service,
        customerType: vm.ruleForm.customerType,
        billetType: vm.ruleForm.billetType,
        serviceType: vm.ruleForm.serviceType,
      }, type)
        .then((response) => {
          vm.tablePrepost = response;
          vm.dialog.post = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    show(id) {
      const vm = this;
      vm.current = id;
      let record = vm.tableData.find(x => x.customerId === id);
      if (!record) record = vm.tablePartners.find(x => x.partnerId === vm.current);
      if (record) {
        for (const services of record.servicesAdicional.filter(x => x.serviceId)) {
          const row = vm.tableServices.find(x => x.serviceId === services.id);
          if (!row) {
            vm.tableServices.push({
              id: vm.current,
              serviceId: services.id,
              content: services.name,
              value: +services.value,
            })
          }
        }
      }
      vm.dialog.servicesadd = true;
    },
    discount(id) {
      const vm = this;
      vm.current = id;
      let record = vm.tableData.find(x => x.customerId === id);
      if (!record) record = vm.tablePartners.find(x => x.partnerId === vm.current);
      if (record) {
        vm.ruleForm.discount = record.comments;
      }
      vm.dialog.discount = true;
    },
    saveDiscount() {
      const vm = this;
      let record = vm.tableData.find(x => x.customerId === vm.current);
      if (record) {
        record.comments = vm.ruleForm.discount;
      }
      vm.dialog.discount = false;
    },
    save() {
      const vm = this;
      let record = vm.tableData.find(x => x.customerId === vm.current);
      if (record) {
        const total = vm.tableServices.filter(x => x.id == vm.current).reduce((a, b) => {
          return a + +b.value;
        }, 0);
        record.servicesAdicional = vm.tableServices.filter(x => x.id == vm.current);
        record.services = total;
        record.total = vm.ruleForm.customerType !== '2' ?
          +record.price + +record.reversePricetable + +total :
          +record.value + +total + ((+record.factor / 100) * +record.royalties) + ((+record.plataform / 100) * record.royalties);
        if (record.discount) {
          record.total = record.total - +record.discount;
        }
      } else {
        record = vm.tablePartners.find(x => x.partnerId === vm.current);

        if (record) {
          const total = vm.tableServices.filter(x => x.id == vm.current).reduce((a, b) => {
            return a + +b.value;
          }, 0);
          record.valuePricetable = +record.valuePricetable + +total;
          record.servicesAdicional = vm.tableServices.filter(x => x.id == vm.current);
        }
      }
      vm.dialog.servicesadd = false;
    },
    add() {
      const vm = this;
      vm.tableServices.push({
        id: vm.current,
        serviceId: null,
        content: vm.form.content,
        value: vm.form.value,
      });
    },
    remove(index) {
      const vm = this;
      vm.tableServices.splice(index, 1);
    },
    getSummaries(param) {
      var vm = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 || index === 6 || index === 5 || index === 8) {
          sums[index] = "";
          return;
        } else if (index === 1) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          const total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(total);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    back() {
      var vm = this;
      vm.$router.replace({
        name: "cockpit.admin.billing",
      });
    },
    calc(index) {
      const vm = this;
      const row = vm.tableData[index];
      console.log('row', row)
      const total = vm.ruleForm.customerType !== '2' 
        ? +row.price + +row.services + +row.reversePricetable 
        : +row.value + +row.services + ((+row.factor / 100) * +row.royalties) + ((+row.plataform / 100) * row.royalties);
        
      if (row.discount) {
        row.total = total - +row.discount;
      } else {
        row.total = total;
      }
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      InvoiceServices.pendencies({
        startedAt: vm.ruleForm.start[0],
        finishedAt: vm.ruleForm.start[1],
        customer: vm.ruleForm.customer,
        service: vm.ruleForm.service,
        customerType: vm.ruleForm.customerType,
        billetType: vm.ruleForm.billetType,
        serviceType: vm.ruleForm.serviceType,
        shipping: vm.ruleForm.shipping,
      })
        .then((response) => {
          vm.tableData = vm.ruleForm.customerType == '2' ? response.partners : response.records;
          vm.header = response.header;
          vm.tablePartners = response.partners;
          if (response.records.length > 0) vm.activeName = '2';
          else {
            vm.$message({
              type: "warning",
              message: "Nenhum registro encontrado!",
            });
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      if (vm.$refs.tableInvoice.selection.length === 0) {
        return vm.$message({
          type: "error",
          message: "Selecione os clientes para faturar!",
        });
      }
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          InvoiceServices.add(vm.$refs.tableInvoice.selection, {
            startedAt: vm.ruleForm.start[0],
            finishedAt: vm.ruleForm.start[1],
            customer: vm.ruleForm.customer,
            service: vm.ruleForm.service,
            customerType: vm.ruleForm.customerType,
            serviceType: vm.ruleForm.serviceType,
            billetType: vm.ruleForm.billetType,
          })
            .then((response) => {
              vm.$message({
                type: "success",
                message: i18n.tc("faturas-geradas-sucesso"),
              });
              loading.close()
              vm.fetchRecords();
            })
            .catch((error) => {
              loading.close()
              vm.$message({
                type: "error",
                message: error,
              });
            })
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.item-badge {
  margin-top: 10px;
  margin-right: 40px;
}

.discount {
  width: 80px !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.el-date-editor--date {
  width: 140px !important;
}

.ni {
  color: #fff;
}

.txt-12 {
  font-size: 12px;
}
</style>
